/* @LOADING-ACTIONS */
export const START_LOADING = 'START_LOADING';
export const END_LOADING = 'END_LOADING';

/* @AUTH-ACTIONS */
export const LOGOUT = 'LOGOUT';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const FORGOTPASSWORD_REQUEST = 'FORGOTPASSWORD_REQUEST';
export const FORGOTPASSWORD_SUCCESS = 'FORGOTPASSWORD_SUCCESS';
export const FORGOTPASSWORD_FAILURE = 'FORGOTPASSWORD_FAILURE';

export const RESETPASSWORD_REQUEST = 'RESETPASSWORD_REQUEST';
export const RESETPASSWORD_SUCCESS = 'RESETPASSWORD_SUCCESS';
export const RESETPASSWORD_FAILURE = 'RESETPASSWORD_FAILURE';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const SIGNUPDATA_REQUEST = 'SIGNUPDATA_REQUEST';
export const SIGNUPDATA_SUCCESS = 'SIGNUPDATA_SUCCESS';
export const SIGNUPDATA_FAILURE = 'SIGNUPDATA_FAILURE';

export const ACCEPTUSER_REQUEST = 'ACCEPTUSER_REQUEST';
export const ACCEPTUSER_SUCCESS = 'ACCEPTUSER_SUCCESS';
export const ACCEPTUSER_FAILURE = 'ACCEPTUSER_FAILURE';

export const REJECTUSER_REQUEST = 'REJECTUSER_REQUEST';
export const REJECTUSER_SUCCESS = 'REJECTUSER_SUCCESS';
export const REJECTUSER_FAILURE = 'REJECTUSER_FAILURE';

/* @NEWS-ACTIONS */

export const NEWS_REQUEST = 'NEWS_REQUEST';
export const NEWS_SUCCESS = 'NEWS_SUCCESS';
export const NEWS_FAILURE = 'NEWS_FAILURE';
export const NEWS_DELETE = 'NEWS_DELETE';

/* @FILE-ACTIONS */
export const UPLOAD_PROJ_USER_REQUEST = 'UPLOAD_PROJ_USER_REQUEST';
export const UPLOAD_PROJ_USER_SUCCESS = 'UPLOAD_PROJ_USER_SUCCESS';
export const UPLOAD_PROJ_USER_FAILURE = 'UPLOAD_PROJ_USER_FAILURE';

export const UPLOAD_PROJ_ADMIN_REQUEST = 'UPLOAD_PROJ_ADMIN_REQUEST';
export const UPLOAD_PROJ_ADMIN_SUCCESS = 'UPLOAD_PROJ_ADMIN_SUCCESS';
export const UPLOAD_PROJ_ADMIN_FAILURE = 'UPLOAD_PROJ_ADMIN_FAILURE';

export const UPLOAD_FILE_USER_REQUEST = 'UPLOAD_FILE_USER_REQUEST';
export const UPLOAD_FILE_USER_SUCCESS = 'UPLOAD_FILE_USER_SUCCESS';
export const UPLOAD_FILE_USER_FAILURE = 'UPLOAD_FILE_USER_FAILURE';

/* @PROJECT-ACTIONS */
export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';

export const GET_PROJECT_REQUEST_ADMIN2 = 'GET_PROJECT_REQUEST_ADMIN2';
export const GET_PROJECT_SUCCESS_ADMIN2 = 'GET_PROJECT_SUCCESS_ADMIN2';
export const GET_PROJECT_FAILURE_ADMIN2 = 'GET_PROJECT_FAILURE_ADMIN2';

export const ACCEPT_PROJECT_REQUEST = 'ACCEPT_PROJECT_REQUEST';
export const ACCEPT_PROJECT_SUCCESS = 'ACCEPT_PROJECT_SUCCESS';
export const ACCEPT_PROJECT_FAILURE = 'ACCEPT_PROJECT_FAILURE';

export const REJECT_PROJECT_REQUEST = 'REJECT_PROJECT_REQUEST';
export const REJECT_PROJECT_SUCCESS = 'REJECT_PROJECT_SUCCESS';
export const REJECT_PROJECT_FAILURE = 'REJECT_PROJECT_FAILURE';

export const GET_PUBLISHED_REQUEST = 'GET_PUBLISHED_REQUEST';
export const GET_PUBLISHED_SUCCESS = 'GET_PUBLISHED_SUCCESS';
export const GET_PUBLISHED_FAILURE = 'GET_PUBLISHED_FAILURE';

/* @QUERY-ACTIONS */

export const CONTACTUS_REQUEST = 'CONTACTUS_REQUEST';
export const CONTACTUS_SUCCESS = 'CONTACTUS_SUCCESS';
export const CONTACTUS_FAILURE = 'CONTACTUS_FAILURE';

/* @CLIENT-ACTIONS */
export const ADMIN = 'ADMIN';
export const ADMIN_REQUEST = 'ADMIN_REQUEST';
export const ADMIN_SUCCESS = 'ADMIN_SUCCESS';
export const ADMIN_FAILURE = 'ADMIN_FAILURE';
export const CLIENT_REQUEST = 'CLIENT_REQUEST';
export const CLIENT_SUCCESS = 'CLIENT_SUCCESS';
export const CLIENT_FAILURE = 'CLIENT_FAILURE';
export const GET_TOKEN = 'GET_TOKEN';
export const CLEAR_DATA = 'CLEAR_DATA';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const FORCE_REFRESH = 'FORCE_REFRESH';

/* @INDICATORS */
export const INDICATORS_REQUEST = 'INDICATORS_REQUEST';
export const INDICATORS_SUCCESS = 'INDICATORS_SUCCESS';
export const INDICATORS_FAILURE = 'INDICATORS_FAILURE';


// @Announcement

export const ANNOUNCEMENT_REQUEST = 'ANNOUNCEMENT_REQUEST';
export const ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT_SUCCESS';
export const ANNOUNCEMENT_FAILURE = 'ANNOUNCEMENT_FAILURE';
export const ANNOUNCEMENT_DELETE = 'ANNOUNCEMENT_DELETE';

// Updates
export const UPDATE_REQUEST = 'UPDATE_REQUEST';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';
export const UPDATE_DELETE = 'UPDATE_DELETE';

//newsletter

export const NEWSLETTER_REQUEST ='NEWSLETTER_REQUEST';
export const NEWSLETTER_SUCCESS ='NEWSLETTER_SUCCESS';
export const NEWSLETTER_FAILURE ='NEWSLETTER_FAILURE';
export const NEWSLETTER_DELETE ='NEWSLETTER_DELETE';

//createAdmin

export const CREATEADMIN_REQUEST ='CREATEADMIN_REQUEST';
export const CREATEADMIN_SUCCESS ='CREATEADMIN_SUCCESS';
export const CREATEADMIN_FAILURE ='CREATEADMIN_FAILURE';
export const CREATEADMIN_DELETE ='CREATEADMIN_DELETE';